import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaModule } from 'ng-recaptcha';

import { RemittanceRoutingModule } from './remittance-routing.module';

import { SharedModule } from '../shared/shared.module';

import {
    PageRemittanceListComponent,
    PageRemittanceDetailComponent
} from './pages';

// import {

// } from './modals';

// import {

// } from './components';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        NgSelectModule,
        NgbModule,
        RecaptchaModule,
        RemittanceRoutingModule
    ],
    declarations: [
        PageRemittanceListComponent,
        PageRemittanceDetailComponent,
    ]
})
export class RemittanceModule {

}